<template>
    <div class="info">
        <div class="info__wrapper info__wrapper--desc">
            <div class="info__title">
                {{ $lang('welcome.info.bot.title') }}
            </div>
            <div class="info__description">
                <p v-html="$lang('welcome.info.bot.description')"></p>
            </div>
            <div class="info__btns">
                <a class="btn btn--big btn--main-bg info--btn" href='https://t.me/officialy_mk_bot' target="_blank">
                    <img class="form__banner--icon" src="../../../img/icons/aiBotWhite.svg" alt="AI">
                    {{ $lang('welcome.info.bot.btn') }}
                </a>
            </div>
        </div>
        <div class="info__wrapper info__wrapper--imgs">
            <div class="info__imgs--desc">
                <img class="info__img info__img--audio" src="../../../img/welcome/audio.png" alt="bot">
                <img class="info__img info__img--chat" src="../../../img/welcome/chat.png" alt="chat">
                <img class="info__img info__img--line" src="../../../img/welcome/line.png" alt="audio">
                <img class="info__img info__img--phone" src="../../../img/welcome/phone.png" alt="phone">
            </div>
            <div class="info__imgs--mobile">
                <img class="info__img info__img--audio" src="../../../img/welcome/audio.png" alt="bot">
                <img class="info__img info__img--chat-lg" src="../../../img/welcome/chat-lg.png" alt="chat">
                <img class="info__img info__img--line-lg" src="../../../img/welcome/line-lg.png" alt="audio">
                <img class="info__img info__img--ai" src="../../../img/welcome/ai.png" alt="ai">
                <img class="info__img info__img--phone-lg" src="../../../img/welcome/phone-lg.png" alt="phone">
            </div>
        </div>
        <div class="info__btns--mobile">
            <a class="btn btn--big btn--main-bg info--btn" href='https://t.me/officialy_mk_bot' target="_blank">
                <img class="form__banner--icon" src="../../../img/icons/aiBotWhite.svg" alt="AI">
                {{ $lang('welcome.info.bot.btn') }}
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'WelcomeBotInfo'
}
</script>

<style lang="scss" scoped>
@import "../../../scss/variables";

.info {
    display: flex;
    align-items: center;
    margin-top: 100px;

    @media (max-width: $screen-md - 1) {
        flex-direction: column;
        margin-top: 40px;
    }
}
.info__wrapper {
    display: flex;

    &--desc {
        flex-direction: column;
        width: 40%;
        margin-right: 20px;

        @media (max-width: $screen-xl - 1) {
            width: 55%;
        }

        @media (max-width: $screen-md - 1) {
            width: 100%;
        }

        @media (max-width: $screen-md - 1) {
            margin: 0;
        }
    }

    &--imgs {
        position: relative;
        width: 740px;
        height: 515px;
        border: 1px solid #C0C9DA4D;
        background: #F8F9FC;
        border-radius: 10px;

        @media (max-width: $screen-xl - 1) {
            width: 700px;
            height: 410px;
        }

        @media (max-width: $screen-lg - 1) {
            width: 350px;
            background: unset;
            border: unset;
        }

        @media (max-width: $screen-md - 1) {
            margin-top: 40px;
            height: 380px;
        }

        @media (max-width: $screen-sm - 1) {
            width: 330px;
        }
    }
}
.info__title {
    font-family: $font-family-secondary;
    font-size: 40px;
    font-weight: 600;
    letter-spacing: -1.25px;
    text-align: left;
    margin-bottom: 20px;

    @media (max-width: $screen-md - 1) {
        font-size: 4rem;
    }

    @media (max-width: 560px) {
        font-size: 28px;
    }
}
.info__description {
    font-family: $font-family-primary;
    font-size: 16px;
    font-weight: 300;
    letter-spacing: -0.25px;
    text-align: left;
    margin-bottom: 20px;

    @media (max-width: 560px) {
        font-size: 14px;
    }
}
.info__btns {
    @media (max-width: $screen-md - 1) {
        display: none;
    }

    &--mobile {
        display: none;

        @media (max-width: $screen-md - 1) {
            display: block;
        }

        @media (max-width: $screen-sm - 1) {
            width: 100%;
        }
    }
}
.info--btn {
    border-radius: 10px;

    @media (max-width: $screen-sm - 1) {
        width: 100%;
        height: 54px;
    }
}
.info__imgs {
    &--desc {
        @media (max-width: $screen-lg - 1) {
            display: none;
        }
    }

    &--mobile {
        display: none;
        @media (max-width: $screen-lg - 1) {
            display: block;
        }
    }
}
.info__img {
    position: absolute;

    &--phone {
        right: 20px;
        top: -80px;
        z-index: 100;

        @media (max-width: $screen-xl - 1) {
            width: 350px;
            top: -60px;
        }
    }

    &--phone-lg {
        width: 300px;
    }

    &--audio {
        bottom: 85px;
        z-index: 300;
        right: 95px;
        width: 365px;
        border-radius: 10px;
        box-shadow: 0 40px 40px 0 #BEBEBE29;

        @media (max-width: $screen-xl - 1) {
            width: 300px;
            bottom: 50px;
            right: 50px;
        }

        @media (max-width: $screen-lg - 1) {
            bottom: 105px;
            right: 40px;
        }

        @media (max-width: $screen-md - 1) {
            bottom: 60px;
        }
    }

    &--chat {
        width: 290px;
        top: 50px;
        left: 40px;

        @media (max-width: $screen-xl - 1) {
            width: 250px;
            top: 35px;
            left: 30px;
        }
    }

    &--chat-lg {
        width: 250px;
        z-index: 300;
        right: 0;
        top: -30px;
    }

    &--line {
        width: auto;
        bottom: 105px;
        left: 25px;

        @media (max-width: $screen-xl - 1) {
            width: 180px;
            bottom: 70px;
            left: 20px;
        }
    }

    &--line-lg {
        width: auto;
        right: 35px;
        top: 38px;
        height: 170px;
    }

    &--ai {
        width: 49px;
        right: 105px;
        top: 100px;
        z-index: 300;
    }
}
</style>
